var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound33B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 12,
  fill: "#464D57"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 4h10l.752 8.274A2.5 2.5 0 0 1 33.262 15h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 6 .223-.445A2.813 2.813 0 0 1 26.738 4h6.524c1.065 0 2.039.602 2.515 1.555L36 6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m9.983 47.33-5-8.66 6.79-4.788a2.5 2.5 0 0 1 3.606.793l3.262 5.65a2.5 2.5 0 0 1-1.116 3.52L9.983 47.33Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m12.215 47.196-.496.03a2.812 2.812 0 0 1-2.605-1.401l-3.261-5.65a2.813 2.813 0 0 1 .088-2.956l.274-.415"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m55.017 38.67-5 8.66-7.542-3.486a2.5 2.5 0 0 1-1.116-3.519l3.262-5.65a2.5 2.5 0 0 1 3.606-.793l6.79 4.788Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m53.785 36.804.274.415c.587.89.621 2.033.089 2.956l-3.262 5.65a2.812 2.812 0 0 1-2.605 1.4l-.496-.029"
})));
SvgRound33B.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound33B);
export default ForwardRef;